export enum TableRowEditMode {
  Dialog = 'dialog',
  Cell = 'cell',
}
